
import store from '@/store';
import ChatModule from '@/store/modules/Chat';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

const chatModule = getModule(ChatModule, store);

@Component
export default class Title extends Vue {
    public standardTitle: string|null = null;
    public title: string|null = null;
    public timer: number|null = null;

    @Watch('firstUnread')
    unreadChanged() {
        clearInterval(this.timer || undefined);
        this.title = this.standardTitle;
        if (this.firstUnread) {
            this.timer = setInterval(() => {
                console.log(this.firstUnread);
                if (this.title === this.standardTitle) {
                    this.title = `Wiadomość od ${this.firstUnread!.author}`;
                } else {
                    this.title = this.standardTitle;
                }
            }, 1000) as unknown as number;
        }
    }

    @Watch('title')
    titleChanged(title: string) {
        document.title = title;
    }

    get firstUnread() {
        return chatModule.chats.flatMap(
            chat => chat.messages.filter(msg => msg.author !== 'me' && !msg.isRead)
        ).shift();
    }

    mounted() {
        this.standardTitle = document.title;
        this.title = this.standardTitle;
    }
    
    render() {
        'empty function';
    }
}
